export const getVariable = (key, arr) => {
  let result;
  if (arr) {
    const currentItem = arr.find(item => item.key === key);
    if (currentItem) {
      result = Number(currentItem.content) ? Number(currentItem.content) : currentItem.content;
    }
    else result = undefined;
  }
  return result;
}
